// extracted by mini-css-extract-plugin
export var content = "_qn-1";
export var noScroll = "_qn-3";
export var paper = "_qn-0";
export var scrollable = "_qn-2";